import PropTypes from 'prop-types';
import React from 'react';
import BrandForm from './BrandForm';
import { getInitialValuesFromBrand } from '../helpers';

const EditBrand = ({
  brand,
  onSave,
  onDelete,
  onSortChange,
  onShopSelectionChange,
  onMembershipsEnabledChange,
  onApiReaderEnabledChange,
}) => (
  <div>
    <BrandForm
      onSave={onSave}
      onDelete={onDelete}
      onSortChange={onSortChange}
      onShopSelectionChange={onShopSelectionChange}
      onMembershipsEnabledChange={onMembershipsEnabledChange}
      onApiReaderEnabledChange={onApiReaderEnabledChange}
      initialValues={getInitialValuesFromBrand(brand)}
      cancelHref="/admin/brands"
      edit
    />
  </div>
);

EditBrand.propTypes = {
  brand: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  onShopSelectionChange: PropTypes.func.isRequired,
  onMembershipsEnabledChange: PropTypes.func.isRequired,
  onApiReaderEnabledChange: PropTypes.func.isRequired,
};

export default EditBrand;
